// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'multi-device';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.375 17.438h-4.5l.563-3.375h3.374zm-6.187 0h7.875' />
    <path d='M8.438 3.938h7.874a1.125 1.125 0 0 1 1.125 1.124v7.875a1.125 1.125 0 0 1-1.125 1.126H3.938a1.125 1.125 0 0 1-1.124-1.126v-1.124m-.001 0h14.624' />
    <path d='M5.063.563H1.688c-.622 0-1.125.503-1.125 1.125v6.75c0 .62.503 1.124 1.125 1.124h3.375c.62 0 1.125-.503 1.125-1.124v-6.75c0-.622-.504-1.125-1.125-1.125zm-4.5 6.75h5.625' />
  </g>
);

export const viewBox = '0 0 18 18';
